import React from 'react';
import classnames from 'classnames';
import Styled from 'styled';

import Image from '../../common/feed-images/image/image';

import defaultStyles from './feed-images-preview.scss';
import { FeedImagesFragment } from '../../common/feed-images/feed-images.graphql';

interface Props extends Partial<FeedImagesFragment> {
    styles: typeof defaultStyles;
    imgRef: any;
    onClick: any;
    isVendor: boolean;
}

class FeedImagesPreview extends React.PureComponent<Props> {
    render() {
        const { styles, images, newImagesCount, imagesCount, imgRef, onClick, isVendor } = this.props;

        return (
            <ul
                className={classnames(styles.images, {
                    [styles.imagesWithAfter]: newImagesCount && newImagesCount > 1,
                })}
            >
                {images &&
                    images.edges.map((edge, index) => {
                        const notNew = newImagesCount && newImagesCount <= index;
                        const notLoaded = !(edge && edge.node);
                        if (notNew || notLoaded) {
                            return null;
                        }

                        return edge && edge.node && edge.node.photoFile ? (
                            <li
                                key={(edge && edge.node && edge.node.id) || ''}
                                className={classnames(styles.listImage, {
                                    [styles.halfImage]:
                                        (edge.node.photoFile.height || 0) > (edge.node.photoFile.width || 0),
                                    [styles.vendor]: isVendor,
                                })}
                            >
                                <Image
                                    key={edge.node.id}
                                    index={index}
                                    imgRef={imgRef}
                                    onClick={onClick}
                                    onlyChild={newImagesCount === 1 || imagesCount === 1}
                                    {...edge.node}
                                />
                            </li>
                        ) : null;
                    })}
            </ul>
        );
    }
}

export default Styled(defaultStyles)(FeedImagesPreview);
